/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "昨日",
        "-2": "前日",
        "0": "今日",
        "1": "明日",
        "2": "後日",
        "future": {
          "other": "{0} 日後"
        },
        "past": {
          "other": "{0} 日前"
        }
      },
      "day-narrow": {
        "-1": "昨日",
        "-2": "前日",
        "0": "今日",
        "1": "明日",
        "2": "後日",
        "future": {
          "other": "{0}日後"
        },
        "past": {
          "other": "{0}日前"
        }
      },
      "day-short": {
        "-1": "昨日",
        "-2": "前日",
        "0": "今日",
        "1": "明日",
        "2": "後日",
        "future": {
          "other": "{0} 日後"
        },
        "past": {
          "other": "{0} 日前"
        }
      },
      "hour": {
        "0": "這個小時",
        "future": {
          "other": "{0} 小時後"
        },
        "past": {
          "other": "{0} 小時前"
        }
      },
      "hour-narrow": {
        "0": "這個小時",
        "future": {
          "other": "{0}小時後"
        },
        "past": {
          "other": "{0}小時前"
        }
      },
      "hour-short": {
        "0": "這個小時",
        "future": {
          "other": "{0} 小時後"
        },
        "past": {
          "other": "{0} 小時前"
        }
      },
      "minute": {
        "0": "這分鐘",
        "future": {
          "other": "{0} 分鐘後"
        },
        "past": {
          "other": "{0} 分鐘前"
        }
      },
      "minute-narrow": {
        "0": "這分鐘",
        "future": {
          "other": "{0}分後"
        },
        "past": {
          "other": "{0}分前"
        }
      },
      "minute-short": {
        "0": "這分鐘",
        "future": {
          "other": "{0} 分鐘後"
        },
        "past": {
          "other": "{0} 分鐘前"
        }
      },
      "month": {
        "-1": "上個月",
        "0": "本月",
        "1": "下個月",
        "future": {
          "other": "{0} 個月後"
        },
        "past": {
          "other": "{0} 個月前"
        }
      },
      "month-narrow": {
        "-1": "上個月",
        "0": "本月",
        "1": "下個月",
        "future": {
          "other": "{0}個月後"
        },
        "past": {
          "other": "{0}個月前"
        }
      },
      "month-short": {
        "-1": "上個月",
        "0": "本月",
        "1": "下個月",
        "future": {
          "other": "{0} 個月後"
        },
        "past": {
          "other": "{0} 個月前"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "上一季",
        "0": "今季",
        "1": "下一季",
        "future": {
          "other": "{0} 季後"
        },
        "past": {
          "other": "{0} 季前"
        }
      },
      "quarter-narrow": {
        "-1": "上季",
        "0": "今季",
        "1": "下季",
        "future": {
          "other": "+{0}Q"
        },
        "past": {
          "other": "-{0}Q"
        }
      },
      "quarter-short": {
        "-1": "上季",
        "0": "今季",
        "1": "下季",
        "future": {
          "other": "{0} 季後"
        },
        "past": {
          "other": "{0} 季前"
        }
      },
      "second": {
        "0": "現在",
        "future": {
          "other": "{0} 秒後"
        },
        "past": {
          "other": "{0} 秒前"
        }
      },
      "second-narrow": {
        "0": "現在",
        "future": {
          "other": "{0}秒後"
        },
        "past": {
          "other": "{0}秒前"
        }
      },
      "second-short": {
        "0": "現在",
        "future": {
          "other": "{0} 秒後"
        },
        "past": {
          "other": "{0} 秒前"
        }
      },
      "week": {
        "-1": "上星期",
        "0": "本星期",
        "1": "下星期",
        "future": {
          "other": "{0} 星期後"
        },
        "past": {
          "other": "{0} 星期前"
        }
      },
      "week-narrow": {
        "-1": "上星期",
        "0": "本星期",
        "1": "下星期",
        "future": {
          "other": "{0}星期後"
        },
        "past": {
          "other": "{0}星期前"
        }
      },
      "week-short": {
        "-1": "上星期",
        "0": "本星期",
        "1": "下星期",
        "future": {
          "other": "{0} 星期後"
        },
        "past": {
          "other": "{0} 星期前"
        }
      },
      "year": {
        "-1": "上年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0} 年後"
        },
        "past": {
          "other": "{0} 年前"
        }
      },
      "year-narrow": {
        "-1": "上年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0}年後"
        },
        "past": {
          "other": "{0}年前"
        }
      },
      "year-short": {
        "-1": "上年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0} 年後"
        },
        "past": {
          "other": "{0} 年前"
        }
      }
    },
    "locale": "zh-Hant-MO"
  });
}